import { defineStore } from 'pinia';
export const useGrouperStore = defineStore({
    id: 'grouperStore',
    state: () => ({
        aprExpanded: false
    }),
    getters: {
        getAprExpanded: (state) => state.aprExpanded
    },
    actions: {
        expandCollpaseApr() {
            this.aprExpanded = !this.aprExpanded;
        }
    }
})